/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveSessionMeetParticipantsCount } from '../../models/live-session-meet-participants-count';

export interface ApiLiveSessionGoogleCountParticipantsItemIdGet$Params {
  item_id: number;
}

export function apiLiveSessionGoogleCountParticipantsItemIdGet(http: HttpClient, rootUrl: string, params: ApiLiveSessionGoogleCountParticipantsItemIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveSessionMeetParticipantsCount>> {
  const rb = new RequestBuilder(rootUrl, apiLiveSessionGoogleCountParticipantsItemIdGet.PATH, 'get');
  if (params) {
    rb.path('item_id', params.item_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveSessionMeetParticipantsCount>;
    })
  );
}

apiLiveSessionGoogleCountParticipantsItemIdGet.PATH = '/api/live_session/google-count-participants/{item_id}';
